// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1jzcR","containerItemsCenter":"Skeleton_containerItemsCenter__23mhi"};